import { MenuSize } from "@flatfile/design-system";
const TOOLBAR_TOOLTIP_ID = "toolbar-tooltip";
({
  defaultOpen: true,
  autoFocus: true,
  isClickOutsideDisabled: true,
  minWidth: 240,
  size: MenuSize.sm,
  searchable: true
});
export {
  TOOLBAR_TOOLTIP_ID
};
